const deleteModes = {
  PATIENT: "patient",
  ASSET: "asset",
  FORMAT: "format",
};

export default deleteModes;
